export default __webpack_public_path__ + "static/media/Home-Map.a9af3f9a.jpg";